<template>
  <div class="sp-el-popper">
    <el-popover
      placement="bottom"
      trigger="click"
      @hide="hide"
      @show="visible = true"
    >
      <div v-if="visible">
        <el-tabs v-model="active" type="card" size="mini">
          <el-tab-pane label="纯色" name="pure"
            ><ColorPicker
              v-if="active === 'pure'"
              :color="color"
              :onChange="onChange"
              :onEndChange="onChange"
          /></el-tab-pane>
          <el-tab-pane label="渐变" name="gradient">
            <ColorPicker
              v-if="active === 'gradient'"
              :is-gradient="true"
              :color="color"
              :onChange="onChange"
              :onEndChange="onChange"
          /></el-tab-pane>
        </el-tabs>
      </div>
      <div slot="reference" class="color-picker__trigger">
        <span>
          <span :style="{ background: value }"></span>
        </span>
      </div>
    </el-popover>
  </div>
</template>



<script>
import { ColorPicker } from "./ColorPicker";
import hexToRgb from "../components/ColorPicker/helpers/hexToRgb";

export default {
  props: {
    value: {
      type: String,
      default: "#fff"
    }
  },
  components: {
    ColorPicker
  },
  computed: {
    color: {
      get() {
        if (this.value.indexOf("#") !== -1) {
          const rgb = hexToRgb(this.value);
          const { red, green, blue } = rgb;
          console.log(" { red, green, blue, alpha: 1 }:", {
            red,
            green,
            blue,
            alpha: 1
          });
          return { red, green, blue, alpha: 1 };
        } else {
          var values =
            this.value.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)/) || [];
          if (values[1]) {
            const reg = {
              red: parseInt(values[1]),
              green: parseInt(values[2]),
              blue: parseInt(values[3]),
              alpha: 1
            };
            return reg;
          }
          return {};
        }
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  data() {
    return {
      active: "pure",
      visible: false
    };
  },
  created() {
    console.log("create");
  },
  methods: {
    onChange(attrs) {
      this.color = attrs.style;
    },
    hide() {
      this.visible = false;
      this.active = "pure";
    }
  }
};
</script>

<style lang="less">
.sp-el-popper {
  .color-picker__trigger {
    width: 70px;
    height: 32px;
    display: inline-block;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 4px;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
    font-size: 0;
    position: relative;
    cursor: pointer;
    > span {
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAIAAADZF8uwAAAAGUlEQVQYV2M4gwH+YwCGIasIUwhT25BVBADtzYNYrHvv4gAAAABJRU5ErkJggg==);
      position: relative;
      display: block;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      border: 1px solid #999;
      border-radius: 2px;
      width: 100%;
      height: 100%;
      text-align: center;
      > span {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/components/SpPickerGradientColor.vue